export default {"src":"/_next/static/media/transit-transit_hub.192a8136.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};